<template>
  <div>
    <!-- SEARCH ICON DESKTOP -->
    <div class="search-wrapper d-none d-lg-flex">
      <SearchField v-model="searchText" :searchBoxStyle="'drawer'" />
    </div>
    <!-- SEARCH ICON MOBILE -->
    <div class="search-wrapper d-flex justify-content-end d-lg-none">
      <button
        class="btn -stripped search-field-icon"
        title="Search"
        @click.prevent="$emit('toggle')"
      >
        <Icon
          class="search-field-icon-svg"
          :icon="{
            name: 'search',
            color: Globals.colors.primary,
            size: 16,
          }"
        />
      </button>
    </div>
  </div>
</template>

<script>
import SearchField from '@/Scripts/components/layout/Search/SearchField.vue';
import Icon from '@/Scripts/components/shared/svg/Svg.vue';
export default {
  name: 'SearchIconController',
  components: {
    SearchField,
    Icon
  },
  props: {
  },
  data: function () {
    return {
      searchText: ''
    };
  }
};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";
.search-wrapper {
  width: 100%;
  pointer-events: visible;
  form {
    margin-right: 0;
    width: 100%;
  }

  input {
    pointer-events: visible;
    border: 1px solid transparent;
    padding: 0;
    padding-right: 6px;
    outline: 0;
    background-color: transparent;
    font-size: 18px;
    line-height: 24px;
    vertical-align: -webkit-baseline-middle;
  }
  .search-field-icon {
    width: unset;
    @include media-breakpoint-up(lg) {
      margin-top: -4px;
    }
  }
}
</style>
